module.exports = __webpack_public_path__ + "img/loading.296a0e28.svg";